<ul class="steps w-full">
    <li class="step-primary"></li>
    <li
        *ngFor="let step of stepLabels | keyvalue"
        class="step after:!w-6 after:!h-6 font-bold"
        data-content=""
        [ngClass]="{
            'step-primary': step.key <= currentStep,
            'text-gray-400': step.key > currentStep
        }"
    >
        {{ step.value }}
    </li>
    <li class="step after:!w-0 after:!h-0" data-content="" [ngClass]="{ 'step-primary': currentStep === lastStepIndex }"></li>
</ul>
